import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCartContext } from "@/src/context/CartContext";

type Fields = {
    email: string; firstName: string; lastName: string;
    address: string; city: string; postcode: string;
    cardNumber: string; expiry: string; cvv: string;
};

const INITIAL: Fields = {
    email: "", firstName: "", lastName: "",
    address: "", city: "", postcode: "",
    cardNumber: "", expiry: "", cvv: "",
};

function Field({ label, ...props }: { label: string } & React.InputHTMLAttributes<HTMLInputElement>) {
    return (
        <div>
            <label className="block text-xs uppercase tracking-widest text-stone-400 mb-2">{label}</label>
            <input
                {...props}
                className="w-full border border-stone-200 px-4 py-3 text-sm font-light focus:outline-none focus:border-stone-900 transition-colors bg-white"
            />
        </div>
    );
}

export function CheckoutForm() {
    const [fields, setFields] = useState<Fields>(INITIAL);
    const { clearCart } = useCartContext();
    const navigate = useNavigate();

    const set = (k: keyof Fields) => (e: React.ChangeEvent<HTMLInputElement>) =>
        setFields((f) => ({ ...f, [k]: e.target.value }));

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const orderNumber = `BT-${Math.floor(10000 + Math.random() * 90000)}`;
        clearCart();
        navigate("/order-confirmation", { state: { orderNumber } });
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-10">
            <div>
                <h2 className="font-serif text-xl italic mb-6">Contact</h2>
                <Field label="Email address" type="email" required value={fields.email} onChange={set("email")} />
            </div>

            <div>
                <h2 className="font-serif text-xl italic mb-6">Delivery</h2>
                <div className="grid grid-cols-2 gap-4 mb-4">
                    <Field label="First name" required value={fields.firstName} onChange={set("firstName")} />
                    <Field label="Last name" required value={fields.lastName} onChange={set("lastName")} />
                </div>
                <div className="space-y-4">
                    <Field label="Address" required value={fields.address} onChange={set("address")} />
                    <div className="grid grid-cols-2 gap-4">
                        <Field label="City" required value={fields.city} onChange={set("city")} />
                        <Field label="Postcode" required value={fields.postcode} onChange={set("postcode")} />
                    </div>
                </div>
            </div>

            <div>
                <h2 className="font-serif text-xl italic mb-6">Payment</h2>
                <div className="space-y-4">
                    <Field label="Card number" placeholder="1234 5678 9012 3456" required value={fields.cardNumber} onChange={set("cardNumber")} />
                    <div className="grid grid-cols-2 gap-4">
                        <Field label="Expiry" placeholder="MM / YY" required value={fields.expiry} onChange={set("expiry")} />
                        <Field label="CVV" placeholder="123" required value={fields.cvv} onChange={set("cvv")} />
                    </div>
                </div>
            </div>

            <button
                type="submit"
                className="w-full bg-stone-900 text-white py-4 text-sm uppercase tracking-widest hover:bg-stone-800 transition-colors"
            >
                Place Order
            </button>
        </form>
    );
}
